var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"container"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Simple Upload")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/form"}},[_vm._v("Google Integration")])],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }